export default __webpack_public_path__ + "static/media/tagging_transactions.a65a296c.png";